module.exports = __webpack_public_path__ + "media/images/steps/step_17-85810905aa01e7c19c4cbd8472dd7f98.svg";